<template>
  <div class="liquor-sticky" @click="onClick" v-show="isTop">
    <img src="/liquor/置顶.png" />
  </div>
</template>

<script>
export default {
  name: "Sticky",
  data() {
    return {
      scrollTop: 0
    };
  },
  computed: {
    isTop: function() {
      return this.scrollTop > 500;
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll(e) {
      this.scrollTop = e.target.documentElement.scrollTop;
    },
    onClick(e) {
      window.scrollBy(0, -10000);
    }
  }
};
</script>

<style lang="scss">
.liquor-sticky {
  width: 38px;
  height: 38px;
  background: rgba(228, 200, 150, 1);
  box-shadow: 0px 9px 18px 0px rgba(0, 0, 0, 0.06);

  cursor: pointer;
  position: fixed;
  right: calc((100vw - 1100px) / 2 - 100px);
  bottom: 100px;

  text-align: center;

  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 12px;
    height: 16px;
  }
}
</style>